import React from 'react'
import Breadcrumb from '../../../../Components/Utils/Breadcrumb'
import { BackButton } from '../../../../Components/Utils/Buttons'
import InspectorSetting from './Inspector'

function IndexInspector() {
  return (
    <div className="w-full h-full px-4 py-2">
    <div className="w-full flex justify-between items-center">
      <Breadcrumb
        items={[
          {
            name: "Settings",
          },
          {
            name: "Inspector",
          },
        ]}
      />
      <BackButton />
    </div>
    <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto  p-2 rounded-md overflow-y-scroll">
      <div className=" w-full md:w-[60%] flex justify-between items-center">
<InspectorSetting/>
        </div>
        </div>
        </div>
  )
}

export default IndexInspector